// Constants/Restaurant.js
export const FORM_RESTAURANT_REGISTER = {
    name: "",
    categoriaPrincipal: "", // 👈 string (Comida, Mandados, Otros)
    categorias: [],       // array de strings
    direccion: "",
    lat: "",               // se convierte a number al enviar
    lng: "",               // se convierte a number al enviar
    tiempoEntregaEstimado: 30,
    costoEnvio: 35,
    phone: "",
    email: "",
    isActive: false
};
